import { Pipe, PipeTransform } from "@angular/core";
import { ChartContextType, SearchGroup } from '@core/data';
import { PropertyDataContext } from '@library';

@Pipe({
    name: 'filterByCategoryContext',
    pure: true,
})
export class FilterByCategoryContext implements PipeTransform {
    transform(groups: SearchGroup<any>[] | null, context: ChartContextType): SearchGroup<any>[] | null {
        if (!groups || !context) return groups;

        const excludedCategories = this.getExcludedCategories(context);

        if (excludedCategories.length === 0) return groups;

        return groups.filter(group => !excludedCategories.includes(group.id));
    }

    private getExcludedCategories(context: ChartContextType): string[] {
        switch (context) {
            case ChartContextType.CULTIVAR:
                // Return the 'id' of the SearchGroups you want to REMOVE
                return [PropertyDataContext.SAMPLE, PropertyDataContext.EVALUATION, PropertyDataContext.SITE];
            case ChartContextType.SITE:
                return [PropertyDataContext.CULTIVAR, PropertyDataContext.SAMPLE, PropertyDataContext.EVALUATION];
            case ChartContextType.SAMPLE:
                return [PropertyDataContext.EVALUATION];
            case ChartContextType.EVALUATION:
                return [PropertyDataContext.MISCELLANEOUS];
            default:
                return [];
        }
    }
}